import _toConsumableArray from "/var/lib/jenkins/workspace/edu-main-ui-pre/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.find.js";
import "core-js/modules/es.json.parse.js";
import "core-js/modules/es.json.stringify.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import { renderSlot as _renderSlot, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, createCommentVNode as _createCommentVNode, unref as _unref, withCtx as _withCtx } from "vue";
var _hoisted_1 = {
  class: "check-edit"
};
var _hoisted_2 = {
  key: 0,
  class: "check"
};
var _hoisted_3 = ["onClick"];
var _hoisted_4 = {
  key: 1,
  class: "result"
};
var _hoisted_5 = {
  class: "info"
};
var _hoisted_6 = {
  class: "comment"
};
var _hoisted_7 = {
  class: "file"
};
var _hoisted_8 = {
  class: "top"
};
var _hoisted_9 = {
  key: 1
};
var _hoisted_10 = {
  key: 2,
  class: "tools"
};
import { computed, ref, watch } from 'vue';
import fileList from '@/components/FileList';
import uploadFile from '@/components/UploadFile';
/**
 * 达标验收详情编辑和预览组件
 */
import { getStore } from '@/util/store';
export default {
  __name: 'index',
  props: {
    data: {
      type: Object,
      default: function _default() {}
    },
    value: {
      type: Number,
      default: 1
    },
    // 删除按钮状态
    deleteLoading: {
      type: Boolean,
      default: false
    },
    // 提交按钮状态
    submitLoading: {
      type: Boolean,
      default: false
    },
    columns: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    params: {
      type: Object,
      default: function _default() {}
    }
  },
  emits: ['submit', 'cancel', 'delete'],
  setup: function setup(__props, _ref) {
    var __emit = _ref.emit;
    var props = __props;
    var emits = __emit;
    var userInfo = getStore({
      name: 'userInfo'
    });
    var result = [{
      name: '优秀',
      value: 1,
      icon: 'face-excellent'
    }, {
      name: '合格',
      value: 2,
      icon: 'face-qualified'
    }, {
      name: '不合格',
      value: 3,
      icon: 'face-unqualified'
    }];
    var isReadonly = ref(true);
    var recordResultVal = ref(''); // 评价结果值
    var evidenceVal = ref([]); // 附件
    var commentVal = ref(''); // 评语

    // 允许编辑和删除 验收人id === 当前用户id && 在当前周期
    var isAllowEditDelete = computed(function () {
      var _props$columns, _props$data;
      var isCurrentPeriod = (_props$columns = props.columns) === null || _props$columns === void 0 || (_props$columns = _props$columns.find(function (item) {
        return item.value === props.params.periodId;
      })) === null || _props$columns === void 0 ? void 0 : _props$columns.isCurrentCycle;
      var limits = ((_props$data = props.data) === null || _props$data === void 0 ? void 0 : _props$data.evaluatorId) === userInfo.id ? true : false;
      return limits && isCurrentPeriod;
    });
    // 监听传值
    watch(function () {
      return props.data;
    }, function (val) {
      var _ref2 = val || {},
        recordResult = _ref2.recordResult,
        comment = _ref2.comment,
        evidence = _ref2.evidence;
      recordResultVal.value = result.find(function (item) {
        return item.name === recordResult;
      }).value;
      commentVal.value = comment;
      evidenceVal.value = evidence ? JSON.parse(evidence) : [];
    }, {
      immediate: true,
      deep: true
    });

    // 重新评价 单选
    var handleSelect = function handleSelect(item) {
      recordResultVal.value = item.value;
    };

    /**
     * 上传文件
     */
    var uploadEvent = function uploadEvent(list) {
      var _props$data2;
      var oldEvidence = JSON.parse((_props$data2 = props.data) === null || _props$data2 === void 0 ? void 0 : _props$data2.evidence) || [];
      evidenceVal.value = oldEvidence !== null && oldEvidence !== void 0 && oldEvidence.length ? [].concat(_toConsumableArray(oldEvidence), _toConsumableArray(list)) : list;
    };

    /**
     * 删除
     */
    var handleDeleteRecord = function handleDeleteRecord(id) {
      !props.deleteLoading && emits('delete', id);
    };

    /**
     * 提交
     */
    var handleSubmit = function handleSubmit() {
      var _evidenceVal$value;
      var _ref3 = userInfo.value || {},
        currentClass = _ref3.currentClass;
      var payload = {
        id: props.data.id,
        isSelfService: 1,
        projectId: props.data.projectId,
        recordMode: 'GRADE',
        // 指标记录形式：等级（GRADE）
        recordResult: recordResultVal.value,
        targetId: props.data.targetId,
        targetName: props.data.targetName,
        secondNodeId: props.data.secondNodeId,
        secondNodeName: props.data.secondNodeName,
        comment: commentVal.value,
        evidence: (_evidenceVal$value = evidenceVal.value) !== null && _evidenceVal$value !== void 0 && _evidenceVal$value.length ? JSON.stringify(evidenceVal.value) : '',
        objects: [{
          evaluateObjectId: props.data.evaluateObjectId,
          evaluateObjectName: props.data.evaluateObjectName,
          typeOfEvaluateObject: 'PERSON',
          scopeOfLaunchId: currentClass === null || currentClass === void 0 ? void 0 : currentClass.classId,
          scopeOfLaunchName: currentClass === null || currentClass === void 0 ? void 0 : currentClass.className
        }],
        periodId: props.params.periodId // 周期id
      };
      !props.submitLoading && emits('submit', payload);
    };
    return function (_ctx, _cache) {
      var _props$data3, _props$data4, _props$data5, _props$data6, _props$data7;
      var _component_svg_icon = _resolveComponent("svg-icon");
      var _component_t_textarea = _resolveComponent("t-textarea");
      var _component_t_button = _resolveComponent("t-button");
      var _component_t_popconfirm = _resolveComponent("t-popconfirm");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_renderSlot(_ctx.$slots, "title"), _createElementVNode("div", {
        class: _normalizeClass(['title', isReadonly.value ? 'readonly' : 'edit'])
      }, [_createElementVNode("span", null, _toDisplayString((_props$data3 = __props.data) === null || _props$data3 === void 0 ? void 0 : _props$data3.secondNodeName), 1), _createTextVNode(" " + _toDisplayString((_props$data4 = __props.data) === null || _props$data4 === void 0 ? void 0 : _props$data4.targetName), 1)], 2), !isReadonly.value ? (_openBlock(), _createElementBlock("ul", _hoisted_2, [(_openBlock(), _createElementBlock(_Fragment, null, _renderList(result, function (item) {
        return _createElementVNode("li", {
          key: item.value,
          class: _normalizeClass(item.icon),
          onClick: function onClick($event) {
            return handleSelect(item);
          }
        }, [_createVNode(_component_svg_icon, {
          name: item.value === recordResultVal.value ? 'check-type-select' : 'check-type',
          size: "18",
          class: "check-icon"
        }, null, 8, ["name"]), _createVNode(_component_svg_icon, {
          name: item.icon,
          size: "48"
        }, null, 8, ["name"]), _createElementVNode("p", null, _toDisplayString(item.name), 1)], 10, _hoisted_3);
      }), 64))])) : (_openBlock(), _createElementBlock("div", _hoisted_4, [_createElementVNode("div", _hoisted_5, [_createElementVNode("p", null, [_cache[4] || (_cache[4] = _createTextVNode(" 验收结果：", -1)), _createElementVNode("span", null, _toDisplayString((_props$data5 = __props.data) === null || _props$data5 === void 0 ? void 0 : _props$data5.recordResult), 1)]), _createElementVNode("p", null, [_cache[5] || (_cache[5] = _createTextVNode(" 验收人：", -1)), _createElementVNode("span", null, _toDisplayString((_props$data6 = __props.data) === null || _props$data6 === void 0 ? void 0 : _props$data6.evaluatorName), 1)]), _createElementVNode("p", null, [_cache[6] || (_cache[6] = _createTextVNode(" 验收时间：", -1)), _createElementVNode("span", null, _toDisplayString((_props$data7 = __props.data) === null || _props$data7 === void 0 ? void 0 : _props$data7.createTime), 1)])])])), _createElementVNode("div", _hoisted_6, [!isReadonly.value ? (_openBlock(), _createElementBlock(_Fragment, {
        key: 0
      }, [_cache[7] || (_cache[7] = _createElementVNode("h5", null, "添加评语", -1)), _createVNode(_component_t_textarea, {
        modelValue: commentVal.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = function ($event) {
          return commentVal.value = $event;
        })
      }, null, 8, ["modelValue"])], 64)) : (_openBlock(), _createElementBlock(_Fragment, {
        key: 1
      }, [_cache[8] || (_cache[8] = _createElementVNode("h4", null, "评语", -1)), _createElementVNode("section", null, _toDisplayString(commentVal.value || '暂无评语'), 1)], 64))]), _createElementVNode("div", _hoisted_7, [_createElementVNode("div", _hoisted_8, [!isReadonly.value ? (_openBlock(), _createElementBlock(_Fragment, {
        key: 0
      }, [_cache[9] || (_cache[9] = _createElementVNode("h5", null, "添加佐证材料", -1)), _createVNode(_unref(uploadFile), {
        onUpload: uploadEvent
      })], 64)) : (_openBlock(), _createElementBlock("h4", _hoisted_9, "佐证材料"))]), _createVNode(_unref(fileList), {
        value: evidenceVal.value,
        readonly: isReadonly.value
      }, null, 8, ["value", "readonly"])]), isAllowEditDelete.value ? (_openBlock(), _createElementBlock("div", _hoisted_10, [!isReadonly.value ? (_openBlock(), _createElementBlock(_Fragment, {
        key: 0
      }, [_createVNode(_component_t_button, {
        theme: "default",
        style: {
          "margin-right": "16px"
        },
        onClick: _cache[1] || (_cache[1] = function ($event) {
          return isReadonly.value = true;
        })
      }, {
        default: _withCtx(function () {
          return _toConsumableArray(_cache[10] || (_cache[10] = [_createTextVNode("取消", -1)]));
        }),
        _: 1
      }), _createVNode(_component_t_button, {
        color: "#DE3F3F",
        loading: props.submitLoading,
        onClick: handleSubmit
      }, {
        default: _withCtx(function () {
          return _toConsumableArray(_cache[11] || (_cache[11] = [_createTextVNode("提交", -1)]));
        }),
        _: 1
      }, 8, ["loading"])], 64)) : (_openBlock(), _createElementBlock(_Fragment, {
        key: 1
      }, [_createVNode(_component_t_popconfirm, {
        theme: "danger",
        content: "确认要删除吗？",
        onConfirm: _cache[2] || (_cache[2] = function ($event) {
          var _props$data8;
          return handleDeleteRecord((_props$data8 = props.data) === null || _props$data8 === void 0 ? void 0 : _props$data8.id);
        })
      }, {
        default: _withCtx(function () {
          return [_createVNode(_component_t_button, {
            theme: "danger",
            loading: props.deleteLoading,
            style: {
              "margin-right": "16px"
            }
          }, {
            default: _withCtx(function () {
              return _toConsumableArray(_cache[12] || (_cache[12] = [_createTextVNode("删除", -1)]));
            }),
            _: 1
          }, 8, ["loading"])];
        }),
        _: 1
      }), _createVNode(_component_t_button, {
        theme: "primary",
        onClick: _cache[3] || (_cache[3] = function ($event) {
          return isReadonly.value = false;
        })
      }, {
        default: _withCtx(function () {
          return _toConsumableArray(_cache[13] || (_cache[13] = [_createTextVNode("编辑", -1)]));
        }),
        _: 1
      })], 64))])) : _createCommentVNode("", true)]);
    };
  }
};